import axios from 'axios';
import constants from '../../config/constants';

export const GET_GEN_SUBJECT_AND_CODES = 'GET_GEN_SUBJECT_AND_CODES';
export const GET_COMMON_CONFIG = 'GET_COMMON_CONFIG';

export const GET_COMMON_COURSE_AND_CODES = 'GET_COMMON_COURSE_AND_CODES';
export const GET_COMMON_EXAMS = 'GET_COMMON_EXAMS';

export const UPDATE_BACKDROP = 'UPDATE_BACKDROP';

//= ========== Reducer call functions begin ===========//
export const getGenSubAndCodes = subjectCodes => ({
  type: GET_GEN_SUBJECT_AND_CODES,
  subjectCodes,
});

export const getCommonConfig = commonConfigList => ({
  type: GET_COMMON_CONFIG,
  commonConfigList,
});

export const getCourseCodes = courseCodes => ({
  type: GET_COMMON_COURSE_AND_CODES,
  courseCodes,
});

export const getCommonExam = commonExams => ({
  type: GET_COMMON_EXAMS,
  commonExams,
});

export const updateBackdropState = isOpen => ({
  type: UPDATE_BACKDROP,
  isOpen,
});

export const GET_PERMS_MODULES = 'GET_PERMS_MODULES';
export const getPermissionModule = permModules => ({
  type: GET_PERMS_MODULES,
  permModules,
});
//= ========== Reducer call functions begin ===========//

//= ========== User routing begin ===========//
export const fetchCourseCodesService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/config/course-codes/${data.schoolId}`,
      constants.setHeader(data.token)
    );
    return dispatch(getCourseCodes(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchGenSubjectAndCodesService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/config/subject-codes/${data.schoolId}`,
      constants.setHeader(data.token)
    );
    return dispatch(getGenSubAndCodes(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const fetchSchoolCommonConfigServiceApi = async ({ schoolId, token }) => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/config/school-config/${schoolId}`,
      constants.setHeader(token)
    );
    return res?.data;
  } catch (err) {
    return [];
  }
};

export const fetchSchoolCommonConfigService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const resData = await fetchSchoolCommonConfigServiceApi({ schoolId, token });
    dispatch(getCommonConfig(resData));
    return resData;
  } catch (err) {
    console.error(err.response);
  }
};

export const updateSchoolConfigServiceApi = async data => {
  const { method, token, postData } = data;
  let url = '';
  if (method === 'post') {
    url = '/api/config/create-common-config';
  } else {
    url = `/api/config/update-common-config/${postData?.configId}`;
  }
  try {
    const res = await axios[method](constants.API_BASE_URL + url, postData, constants.setHeader(token));
    return res.data;
  } catch (err) {
    console.error(err.response);
  }
};

export const updateSchoolConfigService = data => async () => {
  await updateSchoolConfigServiceApi(data);
};

export const fetchCommonExamService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/config/exam-type-multi-select`,
      constants.setHeader(data.token, data.userId)
    );
    return dispatch(getCommonExam(res.data));
  } catch (err) {
    console.error('fetchCommonExamService ', err.response);
  }
};

export const fetchPermissionModuleService = data => async dispatch => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/moule-permission/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getPermissionModule(res.data));
    return res.data;
  } catch (err) {
    console.error(err.response);
  }
};

export const updatePermissionModuleService = data => async () => {
  const { token, schoolId, postData } = data;
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/moule-permission/${schoolId}`,
    postData,
    constants.setHeader(token)
  );
};

// Attendance configuration (school-wide in/out time window). Mirrors the mobile admin screen
// (scholae-app-v2 src/containers/AdminAttendanceConfig) which talks to the same endpoints.
export const fetchAttendanceConfigService = data => async () => {
  const { token, schoolId } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/attendance-configuration/school/${schoolId}`,
      constants.setHeader(token)
    );
    return res?.data;
  } catch (err) {
    return null;
  }
};

export const saveAttendanceConfigService = data => async () => {
  const { token, postData } = data;
  const method = postData?.attendanceConfigurationId ? 'put' : 'post';
  const res = await axios[method](
    `${constants.API_BASE_URL}/api/attendance-configuration`,
    postData,
    constants.setHeader(token)
  );
  return res.data;
};

export const saveCourseCodeApi = data => {
  return axios.post(
    `${constants.API_BASE_URL}/api/config/course-codes/${data?.postData?.schoolId}`,
    data?.postData,
    constants.setHeader(data?.token)
  );
};

export const saveSubjectCodeApi = data => {
  return axios.post(
    `${constants.API_BASE_URL}/api/config/subject-codes/${data?.postData?.schoolId}`,
    data.postData,
    constants.setHeader(data?.token)
  );
};

export const deleteCodeApi = data => {
  const url =
    data?.formFor === 'showCourseForm'
      ? `/api/config/course-codes/${data?.schoolId}/${data?.code}`
      : `/api/config/subject-codes/${data?.schoolId}/${data?.code}`;
  return axios.delete(`${constants.API_BASE_URL}${url}`, constants.setHeader(data?.token));
};
//= ========== User routing end ===========//
